import * as React from 'react';
import { Select } from '../../ui/Select';
import { GetAllSegments } from '../../util';
import { ISegment } from '../interfaces';
import { getParentSegments } from '../utils';

interface ISegmentParentSelectProps {
  value: number
  onChange: (newValue: number) => void
  label?: string
  required?: boolean
  readOnly?: boolean
}

interface ISegmentParentSelectState {
  segments: ISegment[]
}

export class SegmentParentSelect extends React.Component<ISegmentParentSelectProps, ISegmentParentSelectState> {
  state: ISegmentParentSelectState = {
    segments: []
  }

  componentWillMount() {
    this.loadSegments()
  }

  loadSegments() {
    return GetAllSegments()
      .then((segments) => this.setState({ segments }))
  }

  render() {
    const { segments } = this.state
    const { onChange = () => ({}) } = this.props
    const parentSegments = getParentSegments(segments)

    return (
      <Select<ISegment, 'id'>
        label={this.props.label}
        options={parentSegments}
        value={this.props.value}
        required={this.props.required}
        loading={parentSegments.length <= 0}
        valueKey="id"
        labelKey="segmentName"
        readOnly={this.props.readOnly}
        onChange={(newValue) => onChange(newValue)} />
    )
  }
}
